"use strict";

Shopify.theme.jsFAQ = {
  init: function init($section) {
    Shopify.theme.jsFAQ = $.extend(this, Shopify.theme.getSectionData($section)); // Selectors
    this.$section = $section



    this.$blocks = $section.find('[data-block]')
    this.$questions = $section.find('[data-question]')
    this.$tags = $section.find('[data-tag]')
    this.$searchBar = $section.find('[data-search]')

    this.handleListeners()

  },
  handleListeners: function () {
    this.$searchBar.on('keyup change', this.search.bind(this))
    this.$tags.on('click', this.handleTagClick.bind(this))
    this.$questions.on('click', this.toggleQuestion)
  },
  search: function (e) {
    debugger
    let term = e.target.value.trim().toLowerCase()
    let $activeBlock = $(e.target).parents('.container').find('.faq__block-items:not(:hidden)');
    let $found = $activeBlock.find('[data-heading]').filter(function () {
      return $(this).text().toLowerCase().indexOf(term) >= 0;
    });
    if (!$found.length) {
      $activeBlock.find('[data-not-found]').removeClass('is-hidden')
    }else{
      $activeBlock.find('[data-not-found]').addClass('is-hidden')
    }
    $activeBlock.find('[data-heading]').hide()
    $found.show()
  },
  getActiveBlock: function () {
    let b = false
    this.$blocks.each(function (index, block) {
      if (block.classList.contains('is-active'))
        b = $(block)
    })
    return b
  },
  resetSearch: function () {
    this.$searchBar.val('')
  },
  toggleQuestion: function (e) {
    if ($(this).siblings('[data-answer]').css('display') == 'none') {
      $(this).parent().addClass('is-active')
      $(this).siblings('[data-answer]').slideDown()
    } else {
      $(this).siblings('[data-answer]').slideUp(() => {
        $(this).parent().removeClass('is-active')
      })
    }
  },
  handleTagClick: function (e) {
    let tag = e.target.dataset.tag
    this.openBlock(tag)
  },
  openBlock: function (tag) {
    this.closeBlocks()
    this.$section.find(`[data-block][data-heading="${tag}"]`).addClass('is-active')
  },
  closeBlocks: function () {
    this.resetSearch()
    this.$blocks.removeClass('is-active')
  },
  unload: function unload($section) {
    this.$tags.off('click')
    this.$questions.off('click')
  }
};